/* Japonisme Museum — refinement layer (October 2026). Loaded after jm.js.
   Plain ES5-safe JS, no dependencies; every feature is opt-in by markup. */
(function () {
  "use strict";
  document.documentElement.classList.add("jm-rf");
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  /* Images fade in once loaded. Never leave one hidden: complete images are marked at
     once, failures are marked too, and a later sweep catches any image that finished
     without us seeing its event. Lazy images still waiting to load keep their listener. */
  function initImages() {
    var imgs = $$(".jm-card__img img:first-child:not(.is-loaded), .jm-door__media > img:not(.is-loaded)");
    var mark = function (img) { img.classList.add("is-loaded"); };
    imgs.forEach(function (img) {
      if (img.complete && img.naturalWidth) { mark(img); return; }
      img.addEventListener("load", function () { mark(img); }, { once: true });
      img.addEventListener("error", function () { mark(img); }, { once: true });
    });
    setTimeout(function () { imgs.forEach(function (img) { if (img.complete) mark(img); }); }, 3500);
  }

  /* "Go straight to the shop" disappears once the journey itself offers the way in. */
  function initSkip() {
    var scene = document.getElementById("scene-journey");
    var skip = scene && scene.querySelector("[data-jm-skip]");
    if (!skip || skip.getAttribute("data-ready")) return;
    skip.setAttribute("data-ready", "1");
    var ticking = false;
    function update() {
      ticking = false;
      var total = scene.offsetHeight - window.innerHeight;
      var p = total > 0 ? Math.min(1, Math.max(0, -scene.getBoundingClientRect().top / total)) : 0;
      skip.classList.toggle("is-gone", p > 0.93 || scene.getBoundingClientRect().bottom < 0);
    }
    window.addEventListener("scroll", function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  /* Language buttons: show the choice immediately, before the next page arrives. */
  function initLang() {
    $$(".jm-lang").forEach(function (form) {
      if (form.getAttribute("data-rf")) return;
      form.setAttribute("data-rf", "1");
      $$(".jm-lang__btn", form).forEach(function (btn) {
        btn.addEventListener("click", function () {
          $$(".jm-lang__btn", form).forEach(function (b) {
            if (b === btn) b.setAttribute("aria-current", "true"); else b.removeAttribute("aria-current");
          });
        });
      });
    });
  }

  /* Card image → product page image: name only the clicked card's image so the
     browser can morph it into the product page hero (see jm-refine.css §5). */
  function clearArtNames() {
    $$(".jm-card__img img").forEach(function (img) { if (img.style.viewTransitionName) img.style.viewTransitionName = ""; });
  }
  function initArtMorph() {
    if (document.documentElement.getAttribute("data-rf-morph")) return;
    document.documentElement.setAttribute("data-rf-morph", "1");
    if (!("startViewTransition" in document)) return;
    document.addEventListener("click", function (e) {
      var card = e.target.closest && e.target.closest("a.jm-card");
      if (!card || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
      clearArtNames();
      var img = card.querySelector(".jm-card__img img");
      if (img) img.style.viewTransitionName = "jm-art";
    });
    window.addEventListener("pageshow", clearArtNames);
  }

  function init() { initImages(); initSkip(); initLang(); initArtMorph(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
  document.addEventListener("shopify:section:load", init);
})();
